/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_File_Tree_Toast_Success_TitleInputs */

const es_components_file_tree_toast_success_title = /** @type {(inputs: Components_File_Tree_Toast_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingesta completada`)
};

const en_components_file_tree_toast_success_title = /** @type {(inputs: Components_File_Tree_Toast_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingestion completed`)
};

/**
* | output |
* | --- |
* | "Ingestion completed" |
*
* @param {Components_File_Tree_Toast_Success_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_toast_success_title = /** @type {((inputs?: Components_File_Tree_Toast_Success_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_Toast_Success_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_toast_success_title(inputs)
	return en_components_file_tree_toast_success_title(inputs)
});
export { components_file_tree_toast_success_title as "components.file_tree.toast_success_title" }